/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './MarketplaceListingDetailsRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc#getListingDetailsV1
 */
export const GET_LISTING_DETAILS_V1_QUERY_FIELD_NAME = 'com_hubspot_marketplace_listing_details_rpc_MarketplaceListingDetailsRpc_getListingDetailsV1';
export const GET_LISTING_DETAILS_V1_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_LISTING_DETAILS_V1_QUERY_FIELD_NAME,
  args: ['slug', 'language'],
  fetcher(request, ctx) {
    return chirpClient.call(References.getListingDetailsV1Rpc, {
      timeout: ctx.timeout,
      request
    });
  }
});